import { styled, TableRow } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        background: "#007FFF",
        color: 'white',
        padding: '2px 5px',
        fontSize: 12,
        textTransform: 'uppercase',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
        padding: '2px 5px'
    }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0
    }
}));

export const StyledTableCellAgentInquiry = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        background: "#007FFF",
        color: 'white',
        padding: '3px 5px',
        fontSize: 12,
        textTransform: 'uppercase',
        border: '1px solid lightgray !important'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
        padding: '8px 5px',
        border: '1px solid lightgray !important'
    }
}));

export const StyledTableRowAgentInquiry = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0
    }
}));

